import { createSlice, createSelector } from "@reduxjs/toolkit";

const initialState = {
  id: "",
  // Legacy singular (backward compat con detalles/edición existente)
  buyer: {},
  seller: {},
  // Multi-party arrays (nuevo wizard)
  buyers: [{ representsCompany: false }],
  sellers: [{ representsCompany: false }],
  background: {},
  permission: {},
  contract: {},
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  repertory: null,
  repertoryYear: null,
};

export const cartransferSlice = createSlice({
  name: "cartransfer",
  initialState,
  reducers: {
    clearState: (state) => {
      Object.assign(state, {
        ...initialState,
      });
      return state;
    },
    setEntity: (state, { payload }) => {
      Object.assign(state[payload.entity], payload.data);
    },
    // Actualizar un elemento de buyers o sellers por índice
    setPartyAt: (state, { payload }) => {
      // payload: { role: 'buyers'|'sellers', index: number, data: {} }
      const { role, index, data } = payload;
      if (!state[role]) state[role] = [];
      if (!state[role][index]) state[role][index] = {};
      Object.assign(state[role][index], data);
      // Mantener singular sincronizado con el primero
      if (index === 0) {
        const singular = role === 'buyers' ? 'buyer' : 'seller';
        Object.assign(state[singular], data);
      }
    },
    addParty: (state, { payload }) => {
      // payload: { role: 'buyers'|'sellers', initialData?: {} }
      state[payload.role].push(payload.initialData || {});
    },
    removeParty: (state, { payload }) => {
      // payload: { role: 'buyers'|'sellers', index: number }
      const { role, index } = payload;
      state[role].splice(index, 1);
      if (state[role].length === 0) state[role].push({});
    },
    setId: (state, { payload }) => {
      state.id = payload;
    },
    setRepertory: (state, { payload }) => {
      state.repertory = payload.repertory;
      state.repertoryYear = payload.repertoryYear;
    },
    setCartransfer: (state, { payload }) => {
      Object.assign(state, payload);
    },
  },
  extraReducers: (builder) => {
    // Aquí se pueden agregar casos de async thunks si es necesario
  },
});

export const {
  clearState,
  setEntity,
  setId,
  setRepertory,
  setCartransfer,
  setPartyAt,
  addParty,
  removeParty,
} = cartransferSlice.actions;

export const buyerSelector = (state) => state.cartransfer.buyer;
export const sellerSelector = (state) => state.cartransfer.seller;
export const buyersSelector = (state) => state.cartransfer.buyers;
export const sellersSelector = (state) => state.cartransfer.sellers;
export const backgroundSelector = (state) => state.cartransfer.background;
export const permissionSelector = (state) => state.cartransfer.permission;
export const contractSelector = (state) => state.cartransfer.contract;
export const idSelector = (state) => state.cartransfer.id;

export const cartransferSelector = createSelector(
  [(state) => state.cartransfer],
  (cartransfer) => ({
    buyer: cartransfer.buyer,
    seller: cartransfer.seller,
    buyers: cartransfer.buyers,
    sellers: cartransfer.sellers,
    contract: cartransfer.contract,
    permission: cartransfer.permission,
    background: cartransfer.background,
    repertory: cartransfer.repertory,
    repertoryYear: cartransfer.repertoryYear,
  })
);
